import './CourseCampusDemo.css'
import { Button} from '@mantine/core'
import SectionTitle from '../../../components/SectionTitle/SectionTitle'
import { useState } from 'react'
import CampusDemoModal from './CampusDemoModal'

export default function CourseCampusDemo({isGrand}) {

   const [isModal, setIsModal] = useState(false)


   return (
      <div className={`course-benefits-container ${isGrand ? "course-benefits-container_grand" : ""}`}>
         <div className='course-benefits-heading'>
            < SectionTitle isGrand={isGrand} upText='demo' downText='Conocé el campus virtual' />
            <p className='course-benefits-description'>
               ¿Querés ver cómo es la plataforma con la que vas a potenciar tu futuro? <br />
               Te aseguramos una experiencia de aprendizaje innovadora, flexible y diseñada para que avances a tu ritmo.
               Accedé a clases interactivas, material exclusivo y el apoyo de expertos que te guiarán en cada paso.<br/>
               ¡Sumate y llevá tu formación al siguiente nivel!
            </p>
            <Button color={isGrand ? "var(--color-grand-accent)" : "var(--color-tertiary)"} onClick={() => setIsModal(true)} >Ver campus</Button>
         </div>
         <CampusDemoModal 
            source='SECTION' 
            isModal={isModal} 
            setIsModal={setIsModal} 
         />
      </div>
   )
}
